/// Function for number of doors form input field increment and decrement
let minDoorCount = 2;
let maxDoorCount = 6;
let isApplyToAllDoors = true;
let isMeasurementsValid = true;
let measurementsWarning = '';
class NumberOfDoors extends HTMLElement {
    constructor() {
        super();

        // temporary
        $(this).on('click', (event) => {
            const button = $(event.currentTarget).first();
            const value = +button.data('value');

            const input = $('#numberOfDoors');
            const inputValue = +input.val();
            const nextValue = inputValue + value;

            if (nextValue >= minDoorCount && nextValue <= maxDoorCount) {
                $('#numberOfDoors').val(nextValue);
                const dynamicDoorClass = 'door-' + new Date().getTime();
                if (value == 1) {
                    const template = `<door-option 
                        class="door mirror ${dynamicDoorClass}" 
                        data-order="${nextValue - 1}" 
                        data-type="doorType" 
                        data-door-type="doorType"
                        data-door-insert="mirror"
                        data-value="mirror">
                        </door-option>`;

                    $('.door-design-preview .doors').append(template);


                    addModal(dynamicDoorClass);

                } else if (value == -1) {
                    $('.door-design-preview .doors door-option').last().remove();

                }
                $('.door-design-preview .doors').removeClass('doors-1 doors-2 doors-3 doors-4 doors-5 doors-6').addClass('doors-' + nextValue);

                getValidAddOnOptions();
                calculateDimensions();
                //getPricingEstimates();
            }
        });
    }
}
customElements.define('door-counter-button', NumberOfDoors);


const calculateDimensions = () => {
    const topWidth = +$('#customTopWidth').val();
    const bottomWidth = +$('#customBottomWidth').val();
    const leftHeight = +$('#customLeftHeight').val();
    const rightHeight = +$('#customRightHeight').val();

    var averageWidth = (parseInt(topWidth) + parseInt(bottomWidth)) / 2;
    var averageHeight = (parseInt(leftHeight) + parseInt(rightHeight)) / 2;

    var viewportWidth = window.innerWidth;
    var viewportHeight = window.innerHeight;

    var widthPercentage = (averageWidth / viewportWidth) * 100;
    var heightPercentage = (averageHeight / viewportHeight) * 100;

    // Calculate the aspect ratio based on the input dimensions
    var aspectRatio = averageWidth / averageHeight;

    // Adjust the percentages based on the aspect ratio
    if (widthPercentage > heightPercentage) {
        widthPercentage = 100;
        heightPercentage = (100 / aspectRatio);
    } else {
        heightPercentage = 100;
        widthPercentage = (100 * aspectRatio);
    }

    var previewDoorsHeight = $('.preview-doors').height() - 150;
    var previewDoorsWidth = $('.preview-doors').width() - 150;

    var maxValue = previewDoorsHeight > previewDoorsWidth ? previewDoorsWidth : previewDoorsHeight;
    

    // Convert percentages to pixel values
    var widthInPx = (widthPercentage / 100) * maxValue;
    var heightInPx = (heightPercentage / 100) * maxValue;

    var dynamicDiv = document.querySelector('.doors');
    dynamicDiv.style.width = (widthInPx - 20) + 'px';
    dynamicDiv.style.height = heightInPx + 'px';

    var withFrames = $('.frame .frame-top, .frame .frame-bottom');
    withFrames.css('width', widthInPx + 'px');

    var heightFrames = $('.frame .frame-left, .frame .frame-right');
    heightFrames.css('height', heightInPx + 'px');
}


const createCustomSelectMenus = () => {
    const selectMenus = document.querySelectorAll(".select-menu");
    selectMenus.forEach(optionMenu => {


        const selectBtn = optionMenu.querySelector(".select-btn");
        const options = optionMenu.querySelectorAll(".option");
        const sBtn_text = optionMenu.querySelector(".sBtn-text");


        selectBtn.addEventListener("click", () => {
            optionMenu.classList.toggle("active");

            // if ($(optionMenu).attr('id') === 'frameStyleSelect') {
            //     $('.frame-left, .frame-right, .frame-top, .frame-bottom').addClass('active');
            // };
        });

        options.forEach((option) => {
            option.addEventListener("click", () => {
                const selectedOption = option.querySelector(".option-text").innerText;
                // sBtn_text.innerText = selectedOption;
                // optionMenu.classList.remove("active");


                if (!$('#myModal').hasClass('hidden')) {
                    // sBtn_text.innerText = selectedOption;
                    // optionMenu.classList.remove("active");

                    if (!option.querySelector(".option-text").classList.contains('option-label-only')) {
                        sBtn_text.innerText = selectedOption;
                        optionMenu.classList.remove("active");
                    }

                    var parentOption = document.querySelector('#insertOptionsContainer .sBtn-text').textContent;
                    console.warn(parentOption);

                    // const vinylOptionsContainer = document.getElementById('vinylOptionsContainer');
                    // const colonialOptionsContainer = document.getElementById('colonialOptionsContainer');

                    // if (parentOption !== 'Vinyl' && parentOption !== 'Colonial') {
                    //     vinylOptionsContainer.classList.add('hidden');
                    //     colonialOptionsContainer.classList.add('hidden');
                    //     $('#applyToSelectedDoor').attr('disabled', false);
                    // } else {
                    //     return;
                    // }

                    if (!option.querySelector(".option-text").classList.contains('option-label-only')) {
                        sBtn_text.innerText = selectedOption;
                        optionMenu.classList.remove("active");
                        optionMenu.setAttribute('data-value', selectedOption.toLowerCase());

                    } else {
                        return;
                    }

                    console.log('@@@ Option Modal \n\n', option);

                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase().replace(' ', ''));
                    optionMenu.setAttribute('data-door-type', $(option).attr('data-door-type'));
                    optionMenu.setAttribute('data-door-insert', $(option).attr('data-door-insert'));

                    // if (selectedOption === 'Vinyl') {
                    //     colonialOptionsContainer.classList.add('hidden');
                    //     vinylOptionsContainer.classList.remove('hidden');
                    //     $('#applyToSelectedDoor').attr('disabled', true);
                    // } else if (selectedOption === 'Colonial') {
                    //     vinylOptionsContainer.classList.add('hidden');
                    //     colonialOptionsContainer.classList.remove('hidden');
                    //     $('#applyToSelectedDoor').attr('disabled', true);
                    // } else if (parentOption == 'Vinyl' || parentOption == 'Colonial') {
                    //     $('#applyToSelectedDoor').attr('disabled', false);
                    // }

                    
                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase().replace(' ', ''));
                } else if ($(optionMenu).attr('id') == 'frameStyleSelect') {
                    sBtn_text.innerText = selectedOption;
                    optionMenu.classList.remove("active");
                    // changing the label text in track style
                    if (selectedOption === 'Standard' || selectedOption === 'Frameless') {
                        $('#trackstyle_double').text('83mm wide');
                        $('#trackstyle_triple').text('123mm wide');
                    } else {
                        $('#trackstyle_double').text('53mm wide');
                        $('#trackstyle_triple').text('83mm wide');
                    }

                    payloadData.frameStyle = selectedOption.toLowerCase();
                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase());

                    console.log('@@@ Frame Style Selected', selectedOption);

                    getPricingEstimates();

                } else if ($(optionMenu).attr('id') == 'doorsSettingOnSelect') {
                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase());
                    sBtn_text.innerText = selectedOption;
                    optionMenu.classList.remove("active");
                    if (selectedOption === 'Concrete' || selectedOption === 'Carpet') {
                        $('#add_foorbatten_container #foorbatten_recomendation').removeClass('hidden');
                    } else {
                        $('#add_foorbatten_container #foorbatten_recomendation').addClass('hidden');
                    }
                } else if ($(optionMenu).attr('id') == 'frameColorSelect') {
                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase());
                    sBtn_text.innerText = selectedOption;
                    optionMenu.classList.remove("active");
                    const frameColors = ['white', 'black', 'brightnatural', 'mattnatural'];
                    const frameColor = $('.frame-container .frame');

                    frameColor.removeClass(frameColors.join(' '));
                    frameColor.addClass(selectedOption.toLowerCase().replace(' ', ''));
                    payloadData.frameColor = selectedOption.toLowerCase();
                } else if ($(optionMenu).attr('id') == 'frameStyleSelect') {
                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase());
                    sBtn_text.innerText = selectedOption;
                    optionMenu.classList.remove("active");
                    const frameStyles = ['standard', 'slim-style', 'frameless'];
                    const frame = $('.frame-container .frame');

                    frame.removeClass(frameStyles.join(' '));
                    frame.addClass(selectedOption.toLowerCase().replace(' ', ''));

                    // const classes = $('.frame-container .frame').attr('class').split(' ').pop();
                    // frame.addClass(classes);

                    if (selectedOption.toLowerCase() === 'frameless') {
                        $(`select-image-option[data-name~='doorType']`).removeClass('selected');
                        $(`select-image-option[data-name~='doorVinylOption']`).removeClass('selected');
                        $(`select-image-option[data-name~='doorColonialOption']`).removeClass('selected');

                        $(`select-image-option[data-name~='doorType'][data-value~='gyprock'`).addClass('disabled');
                        $(`select-image-option[data-name~='doorType'][data-value~='vinyl'`).addClass('disabled');
                        $(`select-image-option[data-name~='doorType'][data-value~='colonial'`).addClass('disabled');

                        $('#doortype-vinyl-options').addClass('d-none');
                        $('#doortype-colonial-options').addClass('d-none');

                        // $('door-option').removeClass(
                        //     INSERTS.join(' ') + ' ' +
                        //     VINYL_OPTIONS.join(' ') + ' ' +
                        //     COLONIAL_OPTIONS.join(' ')
                        // );
                    } else {
                        $(`select-image-option[data-name~='doorType'][data-value~='gyprock'`).removeClass('disabled');
                        $(`select-image-option[data-name~='doorType'][data-value~='vinyl'`).removeClass('disabled');
                        $(`select-image-option[data-name~='doorType'][data-value~='colonial'`).removeClass('disabled');

                    }

                    if (selectedOption.toLowerCase() === 'standard' || selectedOption.toLowerCase() === 'frameless') {
                        $('#trackstyle_double').text('83mm wide');
                        $('#trackstyle_triple').text('123mm wide');
                    } else {
                        $('#trackstyle_double').text('53mm wide');
                        $('#trackstyle_triple').text('83mm wide');
                    }

                    getPricingEstimates();
                    
                } else if ($(optionMenu).hasClass('insert-selection')) {
                    console.log('@@@ Insert-Selection: Configurator');
                    const parentOption = document.querySelector('#insertOptionsContainerSideBar .sBtn-text').textContent;
                    const vinylOptionsContainer = document.getElementById('vinylOptionsContainerSideBar');
                    const colonialOptionsContainer = document.getElementById('colonialOptionsContainerSideBar');
                    const addToCartBtn = $('.add-to-cart-btn');


                    if (!option.querySelector(".option-text").classList.contains('option-label-only')) {
                        sBtn_text.innerText = selectedOption;
                        optionMenu.classList.remove("active");
                        optionMenu.setAttribute('data-value', selectedOption.toLowerCase());

                    } else {
                        return;
                    }

                    console.log('@@@ Option \n\n', option);

                    optionMenu.setAttribute('data-value', selectedOption.toLowerCase().replace(' ', ''));
                    optionMenu.setAttribute('data-door-type', $(option).attr('data-door-type'));
                    optionMenu.setAttribute('data-door-insert', $(option).attr('data-door-insert'));


                    const hideBothContainers = () => {
                        vinylOptionsContainer.classList.add('hidden');
                        colonialOptionsContainer.classList.add('hidden');
                    };

                    const applyToAllDoorsIfNeeded = (logMessage) => {
                        if (isApplyToAllDoors) {
                            console.log(logMessage);
                            applyToAllDoors();
                        } else {
                            const hasSelectedDoor = $('door-option.door.selected').length > 0;
                            Swal.fire({
                                title: "Tips",
                                html: `You can apply the same insert to all doors by checking the <b>Apply to all doors</b> checkbox.`,
                                icon: "question",
                                showCancelButton: true,
                                confirmButtonColor: "#f57521",
                                confirmButtonText: "Yes, apply to all",
                                cancelButtonText: `No, apply to ${hasSelectedDoor ? 'chosen' : '1st'} door only`,
                                allowOutsideClick: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    //   Swal.fire({
                                    //     title: "Deleted!",
                                    applyToAllDoors();
                                } else {

                                    applyToFirstDoorOnly();
                                }
                            });
                        }
                    };

                    if (parentOption !== 'Vinyl' && parentOption !== 'Colonial') {
                        hideBothContainers();
                        applyToAllDoorsIfNeeded('@@@ Insert-Selection: Configurator - Apply to all doors');
                        addToCartBtn.attr('disabled', false);
                    } else if (selectedOption === 'Vinyl') {
                        hideBothContainers();
                        vinylOptionsContainer.classList.remove('hidden');
                        addToCartBtn.attr('disabled', true);
                    } else if (selectedOption === 'Colonial') {
                        hideBothContainers();
                        colonialOptionsContainer.classList.remove('hidden');
                        addToCartBtn.attr('disabled', true);
                    } else {
                        applyToAllDoorsIfNeeded('@@@ Insert-Selection: Configurator - Apply to all doors last part');
                        addToCartBtn.attr('disabled', false);
                    }
                    
                }
            });
        });
    });

    $('#colonialOptionsSelect .option').on('mouseenter', function () {
        var value = $(this).data('value');
        $('#colonialOptionsSelect .img-container .' + value).removeClass('hidden');
    }).on("mouseleave", function () {
        // This function is executed when the mouse leaves the element
        var value = $(this).data('value');
        $('#colonialOptionsSelect .img-container .' + value).addClass('hidden');
    });

    $('#colonialOptionsSelectSideBar .option').on('mouseenter', function () {
        var value = $(this).data('value');
        
        $('#colonialOptionsSelectSideBar .img-container .' + value).removeClass('hidden');
    }).on("mouseleave", function () {
        // This function is executed when the mouse leaves the element
        var value = $(this).data('value');
        $('#colonialOptionsSelectSideBar .img-container .' + value).addClass('hidden');
    });


    // Add event listener to remove active class when clicking outside options
    // document.addEventListener("click", (event) => {
    //     selectMenus.forEach(optionMenu => {

    //         if ($(event.target).hasClass('option-label-only')) {
    //             return;
    //         } else if (!optionMenu.contains(event.target)) {
    //             //optionMenu.classList.remove("active");
    //         }
    //     });

    //     //$('.frame-left, .frame-right, .frame-top, .frame-bottom').removeClass('active');
    // });
};


let payloads = [];
window.addEventListener('load', () => {
    createCustomSelectMenus();
    calculateDimensions();

    getValidAddOnOptions();
    loadSuggestedDoorQuantity();

    setTimeout(() => {
        hideLoader($('.preview-image'));
        $('.door-design-preview').addClass('show');
        document.getElementById('startHere').style.display = 'block';
    }, 1500);
    
    $('#addFloorBatten_option').on('change', (e) => {
        getPricingEstimates();
    });


    $('#apply_to_all_doors_sidebar').on('change', (e) => {
        isApplyToAllDoors = e.target.checked;
        if (e.target.checked) {
            $('#applyToAllDoors_Tip').addClass('hidden');
            //$('.door-inserts-control-group').removeClass('show-control-overlay');
            $('.door-inserts-control-group .control-overlay').addClass('hidden');
        } else {
            $('#applyToAllDoors_Tip').removeClass('hidden');
            //$('.door-inserts-control-group').addClass('show-control-overlay');
            $('.door-inserts-control-group .control-overlay').removeClass('hidden');
        }
    });

    // $('.running-total__dialog .hide-dialog').on('click', (event) => {
    //     const dialog = $('.running-total__dialog');
    //     dialog.addClass('d-none');
    // });
    
    document.querySelectorAll('.running-total__dialog .hide-dialog').forEach(function (element) {
        element.addEventListener('click', function (event) {
            var dialog = document.querySelector('.running-total__dialog');
            dialog.classList.add('d-none');
        });
    });


    // // detect if the .contains-child-options is clicked
    // // if clicked, then expand the .child-options inside it
    document.querySelectorAll('.contains-child-options').forEach(function (element) {
        element.addEventListener('click', function (event) {
            element.querySelector('.child-options').classList.toggle('active');
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Select all radio buttons within the trackStyleContainer
    const trackStyleRadios = document.querySelectorAll('#trackStyleContainer input[type="radio"][name="trackStyle"]');
  
    // Function to handle radio change
    const onTrackStyleChange = (event) => {
      console.log(`Track style changed to: ${event.target.value}`);
      getPricingEstimates();
    };
  
    // Add change event listener to each radio button
    trackStyleRadios.forEach(radio => {
      radio.addEventListener('change', onTrackStyleChange);
    });
});

const elements = [
    { id: 'customTopWidth', label: 'top-width-label' },
    { id: 'customBottomWidth', label: 'bottom-width-label' },
    { id: 'customLeftHeight', label: 'left-height-label' },
    { id: 'customRightHeight', label: 'right-height-label' },
];

elements.forEach(({ id, label }) => {
    const element = document.getElementById(id);
    const labelElement = document.getElementById(label);

    element.addEventListener('keyup', (event) => {
        labelElement.textContent = event.currentTarget.value + ' mm';
        if (id === 'customTopWidth' || id === 'customBottomWidth' || id === 'customLeftHeight' || id === 'customRightHeight') {
            //hideErrorMessage(event.currentTarget);
            //updateSummary();
            //calculateDimensions();
        }
    });

    element.addEventListener('focus', () => {
        labelElement.parentNode.classList.add('focus');
    });

    element.addEventListener('blur', () => {
        labelElement.parentNode.classList.remove('focus');
        labelElement.textContent = element.value + ' mm';
        
    });
});

showLoader = (element, message) => {
    element.find('.loader-container').remove();
    const loader = `<div class="loader-container">
        <span class="loader"></span>
        <p class="d-block">${message}</p>
    </div>`;
    element.append(loader);
}

// const loadingContainer = $('#door_summary');
// showLoader(loadingContainer, 'Loading door designer...');

hideLoader = (element) => {
    element.find('.loader-container').remove();
}

let payloadData = null;

showLoader($('.price-title'), 'getting price...');

// getting pricing estimates for the wardrobe doors
getPricingEstimates = () => {
    const loadingContainer = $('.price-title');
    if (loadingContainer.find('.loader-container').length <= 0) {
        showLoader(loadingContainer, 'Calculating price...');
    }
    var service = new DoorDesignerService();

    //service.getApiHealth();

    const doorData = $('door-option');
    const payload = {};

    payload.doors = [];

    for (let index = 0; index < doorData.length; index++) {

        const door = $(doorData[index]);

        // optionMenu.setAttribute('data-door-type', $(option).attr('data-door-type'));
        // optionMenu.setAttribute('data-door-insert', $(option).attr('data-door-insert'));


        payload.doors.push({
            sequenceOrderId: door.attr('data-order'),
            //doorType: door.attr('data-type'),
            //insertMaterial: door.attr('data-value'),
            doorType: door.attr('data-door-type'),
            insertMaterial: door.attr('data-door-insert'),
        });
    }

    var data = new DoorRequestConfiguration();
    data.doorOpeningTopWidth = $('#customTopWidth').val();
    data.doorOpeningBottomWidth = $('#customBottomWidth').val();
    data.doorOpeningLeftHeight = $('#customLeftHeight').val();
    data.doorOpeningRightHeight = $('#customRightHeight').val();
    data.setName = $('#setName').val() + ' - estimates';
    data.doorsSittingOn = $('#doorsSettingOnSelect').attr('data-value');
    data.trackStyle = $('input[type="radio"][data-name="trackStyle"]:checked').val();
    data.frameColor = $('#frameColorSelect').attr('data-value');
    data.frameStyle = $('#frameStyleSelect').attr('data-value');
    data.doors = payload.doors;
    data.addFloorBatten = $('#addFloorBatten_option').is(":checked");
    data.bodyHtml = '';

    payloadData = data;

    updateSummary();

    service.onCreateProductEstimate(data, (e) => {
        createdProduct = e;
        if (e.success) {
            customProductVariantId = e.data.customProductVariantId;

            $('.price-text').html('<span class="text-hightlight">$' + formatNumber(e.data.totalPrice) + '</span> <small>AUD</smal>');

            // display the each prices in running total dialog

            var pricesContainer = $('.running-total__dialog__content__body');
            pricesContainer.empty();
            pricesContainer.append(`<hr class="mt-0 mb-5" />`);

            let table = '<table><tbody>';



            for (let index = 0; index < e.data.prices.length; index++) {
                const item = e.data.prices[index];
                table += `<tr>
            <td>${item.details}</td>
            <td>$${formatNumber(item.price)}</td>`;
            }

            table += `</tbody>
                <tfoot>
                    <tr>
                        <td>
                            <b>Total</b>
                        </td>
                    <td>
                    <b>$${formatNumber(e.data.totalPrice)}</b>
                    </td>
                </tr>
                </tfoot>
            </table>
            `;
            pricesContainer.append(table);
            $('.header-total-price').text('$' + formatNumber(e.data.totalPrice) + ' AUD');


            $('#price-value').text(formatNumber(e.data.totalPrice));
            isMeasurementsValid = true;
        } else {
            isMeasurementsValid = false
        }
        hideLoader(loadingContainer);
        
    });
};

isGetValidAddOnOptionsLoading = false;
getValidAddOnOptions = () => {
    const currentNumberOfDoors = +$('#numberOfDoors').val();
    const loaderContainer = $('.trackStyleContainer').first();
    showLoader(loaderContainer, 'getting valid addon options...');
    showLoader($('.summary-price-and-button'), 'Calculating price');

    var service = new DoorDesignerService();
    service.getGetValidAddOnOptions(currentNumberOfDoors, (result) => {
        if (result.success) {
            // $('select-image-option[data-name="trackStyle"]').addClass('disabled').removeClass('selected');
            $('input[type="radio"][data-name="trackStyle"][data-value="double"]').prop('checked', true);
            $('input[type="radio"][data-name="trackStyle"][data-value="triple"]').addClass('disabled').prop('checked', false).attr('disabled', true)
                .parent().addClass('disabled');
            
            for (let index = 0; index < result.data.validTrackStyleOptions.length; index++) {
                const option = result.data.validTrackStyleOptions[index];
                // const element1 = $(`select-image-option[data-name="trackStyle"][data-value="${option.toLowerCase()}"]`);
                // element1.removeClass('disabled');

                const element = $(`input[type="radio"][data-name="trackStyle"][data-value="${option.toLowerCase()}"]`);
                element.removeClass('disabled');
                element.attr('disabled', false);
                element.parent().removeClass('disabled');

            }

            getPricingEstimates();
        } else {
        // show error message for trackstyle
            console.error(result);
        }
        hideLoader(loaderContainer);
    });
}

// function for updating the step 4 Summary section
updateSummary = () => {
    //onCreateQuotation();
    $('#summaryItems').empty();

    let doorsHtml = '<ul class="summary-door-details">';
    payloadData.doors.forEach(door => {
        const doorType = door.doorType == door.insertMaterial ? ' ' : door.doorType;
        doorsHtml += `<li>Door<span class="text-hightlight">#${(+door.sequenceOrderId +1)} ${doorType} ${door.insertMaterial}</span> (insert)</li>`;
    });
    doorsHtml += '</ul>';

    $('#summaryItems').append(`
        <div class="summary-details">
            <p>
                <span class="text-hightlight">${payloadData.doorOpeningTopWidth}</span>mm (Top Width), 
                <span class="text-hightlight">${payloadData.doorOpeningBottomWidth}</span>mm (Bottom Width), 
                <span class="text-hightlight">${payloadData.doorOpeningLeftHeight}</span>mm (Left Height), 
                <span class="text-hightlight">${payloadData.doorOpeningRightHeight}</span>mm (Right Height), 
                <span class="text-hightlight">${payloadData.trackStyle}</span> (track Style), 
                <span class="text-hightlight">${payloadData.doorsSittingOn}</span> (doors are setting on), 
                <span class="text-hightlight">${payloadData.frameColor}</span> (frame color), 
                <span class="text-hightlight">${payloadData.frameStyle}</span> (frame style), 
                <span class="text-hightlight">${payloadData.doors.length}</span> (doors)
            </p>
        </div>
        ${doorsHtml}`
    );

    // const loadingContainer = $('#door_summary');
    // hideLoader(loadingContainer);
}

formatNumber = (number) => {
    // Check if the number is a valid numeric value
    if (isNaN(number)) {
        return "Invalid number";
    }
    // Use toLocaleString to format the number with comma separators
    // and fixed to 2 decimal places
    return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

$('#button_addToCart').on('click', (e) => {

    var setName = $('#setName');
    if (setName.val().length == 0) {
        setName.parents('.form-group').find('.form-help-message-setname').removeClass('d-none');
        setName.focus();
        const focusDiv = document.getElementById('group-setName');
        focusDiv.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Scroll to the top of the div
        });
        return;
    }

    var topWidth = $('#customTopWidth');
    var bottomWidth = $('#customBottomWidth');
    var leftHeight = $('#customLeftHeight');
    var rightHeight = $('#customRightHeight');
    if (topWidth.val().length == 0 || bottomWidth.val().length == 0 || leftHeight.val().length == 0 || rightHeight.val().length == 0 || !isMeasurementsValid) {
        if (topWidth.val().length == 0) {
            topWidth.parents('.form-group').find('.form-help-message').removeClass('d-none');
            topWidth.focus();
        } else if (bottomWidth.val().length == 0) {
            bottomWidth.parents('.form-group').find('.form-help-message').removeClass('d-none');
            bottomWidth.focus();
        } else if (leftHeight.val().length == 0) {
            leftHeight.parents('.form-group').find('.form-help-message').removeClass('d-none');
            leftHeight.focus();
        } else if (rightHeight.val().length == 0) {
            rightHeight.parents('.form-group').find('.form-help-message').removeClass('d-none');
            rightHeight.focus();
        } else if (!isMeasurementsValid) {
            Swal.fire({
                title: 'Invalid measurements',
                text: measurementsWarning.length == 0 ? 'Please check the measurements and try again.' : measurementsWarning,
                icon: 'error',
                confirmButtonColor: '#F57521',
                allowEscapeKey: false,
                allowOutsideClick: false,
            });
        }

        const focusDiv = document.getElementById('group-measurements');
        focusDiv.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // Scroll to the top of the div
        });
        return;
    }

    Swal.fire({
        title: 'Are all the messurements correct?',
        text: "By clicking YES, you will be able to add this item to your cart.",
        icon: 'warning',
        showCancelButton: true,
        allowEscapeKey: false,
        confirmButtonColor: '#F57521',
        confirmButtonText: 'Yes - add to cart!',
        allowOutsideClick: false,
    }).then((result) => {
        if (result.isConfirmed) {
            onCreateQuotation();
        }
    });
});

arrayToObject = (arr) => {
    return arr.reduce((obj, item, index) => {
        obj[item.propertyName] = item.value;
        return obj;
    }, {});
}

askToGoToCart = () => {
    Swal.fire({
        title: 'Do you want to make new configuration?',
        text: "By clicking YES, you will start over again for new wardrobe configuration.",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#F57521',
        // cancelButtonColor: '#dcdcdc',
        confirmButtonText: 'Yes - I like to create new one!',
        allowOutsideClick: false,
        allowEscapeKey: false,
        cancelButtonText: 'No - Take me to my cart',
    }).then((result) => {
        if (result.isConfirmed) {
            // show step 1
            window.location.reload();
        } else {
            // show cart
            window.location.href = window.routes.cart_url;
        }
    });
}

onAddToCart = (callback) => {
    let formData = {
        items: [{
            id: customProductVariantId,
            quantity: 1,
            properties: arrayToObject(createdProduct.data.properties)
        }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response =>  response.json())
    .then((data) => {
        return callback({
            success: true,
            data: data
        });
    })
    .catch((error) => {
        return callback({
            success: false,
            data: error
        });
    });
}

let customProductVariantId = null;
isCreateQuotationLoading = false;
let createdProduct = null;

onCreateQuotation = () => {
    //const loadingContainer = $('.summary-container').first();
    //showLoader(loadingContainer, 'crafting your wardrobe...');
    var service = new DoorDesignerService();

  //service.getApiHealth();

  // just a single product only for testing
    var payload = payloadData;

    const doorsInfo = payload.doors.map((door) => { 
        const type = door.doorType == 'doorType' ? '' : ` ${door.doorType} (type), `;
        return `<li><b>Door#${door.sequenceOrderId+1}</b>${type}${door.insertMaterial} (insert)</li>`;
    }).join('');

    var data = new DoorRequestConfiguration();
    data.doorOpeningTopWidth = payload.doorOpeningTopWidth;
    data.doorOpeningBottomWidth = payload.doorOpeningBottomWidth;
    data.doorOpeningLeftHeight = payload.doorOpeningLeftHeight;
    data.doorOpeningRightHeight = payload.doorOpeningRightHeight;
    data.setName = $('#setName').val() + ' - ' + new Date().toLocaleString();
    data.doorsSittingOn = payload.doorsSittingOn;
    data.trackStyle = payload.trackStyle;
    data.frameColor = payload.frameColor;
    data.frameStyle = payload.frameStyle;
    data.doors = payload.doors;
    data.addFloorBatten  = $('#addFloorBatten_option').is(":checked");
    data.bodyHtml = ` <div class="row">
        <div class="item-name col">
            <h3>${data.setName.toUpperCase()}</h3>
            <p class="mr-3 mb-0" id="summary_orderDetails">
            <i>${payload.doorOpeningTopWidth}mm (Top Width), ${payload.doorOpeningBottomWidth}mm (Bottom Width), ${payload.doorOpeningLeftHeight}mm (Left Height), 
                ${payload.doorOpeningRightHeight}mm (Right Height), ${payload.trackStyle} (track Style), ${payload.doorsSittingOn} (doors are setting on),
                ${payload.frameColor} (frame color), ${payload.frameStyle} (frame style), ${payload.doors.length} (doors)
            </i>
            </p>
            <table>
                <tbody>
                    <tr>
                        <td width="100px" style="padding: 10px;">Set Name:</td>
                    <td>
                        <b>${payload.setName.toUpperCase()}</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Top Width:</td>
                    <td>
                        <b>${data.doorOpeningTopWidth}mm</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Bottom Width:</td>
                    <td>
                        <b>${payload.doorOpeningBottomWidth}mm</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Left Height:</td>
                    <td>
                        <b>${payload.doorOpeningLeftHeight}mm</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Right Height:</td>
                    <td>
                        <b>${payload.doorOpeningRightHeight}mm</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Track Style:</td>
                    <td>
                        <b>${payload.trackStyle}</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Doors are sitting on:</td>
                    <td>
                        <b>${payload.doorsSittingOn}</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Add floor batten:</td>
                    <td>
                        <b>${payload.addFloorBatten ? 'Yes' : 'No'}</b>
                    </td>
                    </tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Frame Style:</td>
                    <td>
                        <b> ${payload.frameStyle}</b>
                    </td>
                    </tr>
                    <tr>
                    <tr>
                    <td width="100px" style="padding: 10px;">Frame Color:</td>
                    <td>
                        <b>${payload.frameColor}</b>
                    </td>
                    </tr>
                    <td width="100px" style="padding: 10px;">Number of Doors</td>
                    <td>
                        <b>${payload.doors.length}</b>
                    </td>
                    </tr>
                </tbody>
            </table>
            <br>
            <ul style="margin-rigt: 20px;">${doorsInfo}</ul>
        </div>
    </div>`;


    var element = $(".door-design-preview"); // global variable
    var getCanvas; // global variable
    createdProduct = null;

    Swal.fire({
        title: 'Creating your wardrobe...',
        html: 'Please wait...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    domtoimage.toPng(document.getElementById('door-designer-preview-container'))
        .then(function (dataUrl) {
        data.imageBase64 = dataUrl;

            service.onCreateProduct(data, (e) => {
            createdProduct = e;
            if (e.success) {
                customProductVariantId = e.data.customProductVariantId;
                //showLoader(loadingContainer, 'getting price...');
                service.getProductPriceAudIncGst(e.data.handle, (result) => {
                $('#summaryItems .item-price h3').html(`${formatNumber(result.data)} <small>AUD</small>`);
        
                $('#summary_grandTotal h2').html(`${formatNumber(result.data)} <small class="color-primary">AUD</small>`);
    
                //hideLoader(loadingContainer);

                Swal.fire({
                    title: 'Adding to your cart',
                    html: 'Please wait...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                onAddToCart((e) => {
                    if (e.success) {
                    // show success message
                    // ask what will do next
                    askToGoToCart();
                    } else {
                    // show error message
                    console.error('something went wrong while attempting to add to cart', e.data);
                    }
                });

                });
            } else {
                // show error message
    
                //hideLoader(loadingContainer);
                if (e.data.errors.length == 0 && e.data.message != null) {
                const substringToCheck = "Could not create aggregate product: Product with handle";
    
                if (e.data.message.includes(substringToCheck)) {
                    Swal.fire({
                        title: 'You missed something..',
                        text: "One of more fields are missing. Please check and try again.",
                        icon: 'warning',
                        showCancelButton: false,
                        allowEscapeKey: false,
                        confirmButtonColor: '#F57521',
                        confirmButtonText: 'Take me to step: 3 Inserts',
                        allowOutsideClick: false,
                        footer: '<p>If this keeps happening please <a href="/pages/contact" target="_blank">contact us</a>. Thank you.</p>'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                const focusDiv = document.getElementById('group-setName');
                                focusDiv.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'start' // Scroll to the top of the div
                                });
                            }
                        });
                    }
                } else {
                Swal.fire({
                    title: 'Oppss.. something went wrong.. ',
                    text: e.data.message,
                    icon: 'error',
                    showCancelButton: true,
                    allowEscapeKey: false,
                    confirmButtonColor: '#F57521',
                    confirmButtonText: 'Take me to step: 3 Inserts',
                    denyButtonText: `Reload this page`,
                    allowOutsideClick: false,
                    footer: '<p>If this keeps happening please <a href="/pages/contact" target="_blank">contact us</a>. Thank you.</p>'
                }).then((result) => {
                    if (result.isConfirmed) {
                        var setName = $('#setName');
                        setName.parents('.form-group').find('.form-help-message-setname').removeClass('d-none');
                        setName.focus();
                        const focusDiv = document.getElementById('group-setName');
                        focusDiv.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start' // Scroll to the top of the div
                        });
                    } else {
                        location.reload();
                    }
                });
                }
            }
            });
        });
};



let defaultValues = {
    customTopWidth: 1750,
    customBottomWidth: 1750,
    customLeftHeight: 2050,
    customRightHeight: 1000
};

let hasChanged = false;
let timeoutId = null;
let measurementsRequestController = new AbortController();

['customTopWidth', 'customBottomWidth', 'customLeftHeight', 'customRightHeight'].forEach(id => {
    let input = document.getElementById(id);
    defaultValues[id] = input.value;

    input.addEventListener('input', () => {
        if (input.value !== defaultValues[id]) {
            hasChanged = true;
        }
    });

    input.addEventListener('focus', () => {
        clearTimeout(timeoutId);
    });

    input.addEventListener('blur', () => {
        if (hasChanged) {
            timeoutId = setTimeout(loadSuggestedDoorQuantity, 1500);
        }
    });

    input.addEventListener('keydown', (e) => {
        if (hasChanged) {
            clearTimeout(timeoutId);
            if (measurementsRequestController.signal.aborted === false) {
                measurementsRequestController.abort();
            }
        }
    });
    
    input.addEventListener('keyup', (e) => {
        if (e.target.value === '' || e.target.value === '0') {
            $(input).parents('.form-group').find('.form-help-message-width').removeClass('d-none');
        } else {
            $(input).parents('.form-group').find('.form-help-message-width').addClass('d-none');
        }
    });
});

$('#setName').on('keyup', (e) => { 
    if (e.target.value.length > 0) {
        $(e.target).parents('.form-group').find('.form-help-message-setname').addClass('d-none');
    } else {
        $(e.target).parents('.form-group').find('.form-help-message-setname').removeClass('d-none');
    }
});

isGetSuggestedDoorQuantityLoading = false;

loadSuggestedDoorQuantity = () => {
    const loadingContainer = $('#group-measurements');
    showLoader(loadingContainer, 'getting suggested door count...');
    const topWidth = +$('#customTopWidth').val();
    const bottomWidth = +$('#customBottomWidth').val();
    const leftHeight = +$('#customLeftHeight').val();
    const rightHeight = +$('#customRightHeight').val();

    if (topWidth == 0 || bottomWidth == 0 || leftHeight == 0 || rightHeight == 0) {
        return;
    }

    var service = new DoorDesignerService();

    const container = $('.number-of-doors-form-group').parent('.col-sm-4');
    showLoader(container, 'getting suggested door quantity and addon options...');
    $('.number-of-doors-form-group').parent('.col-sm-4');

    service.getSuggestedDoorQuantity(topWidth, bottomWidth, leftHeight, rightHeight, (e) => {

        $('#measurement-help-message').addClass('d-none');
        if (e.success) {
            $('door-counter-button[data-value="1"], door-counter-button[data-value="1"]').prop('disabled', false);
            minDoorCount = e.data.quantity;
            maxDoorCount = Math.max.apply(Math, e.data.validDoorQuantities);
            $('#numberOfDoors').val(minDoorCount);
            $('#measurement-help-message').parent().find('small').addClass('d-none');

            measurementsWarning = '';
            if (e.data.warning) {
                Swal.fire({
                    icon: 'info',
                    title: 'Oops...',
                    text: e.data.warning,
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    footer: '<a href="/pages/support" target="_blank">Learn more about wardrobe measurements</a>'
                });
                measurementsWarning = e.data.warning;
            }
            updateDoorUiCount();
            getValidAddOnOptions();

        } else {
            minDoorCount = 2;
            maxDoorCount = 2;
            $('#numberOfDoors').val(minDoorCount);
            $('door-counter-button[data-value="1"], door-counter-button[data-value="1"]').prop('disabled', true);
            $('#measurement-help-message').removeClass('d-none').text(e.data.message);
        }
        
        hideLoader(container);
        hideLoader(loadingContainer)
    });
}



// update door ui 
updateDoorUiCount = () => {
    const nextDoorCount = +$('#numberOfDoors').val();
    const currentDoorCount = +$('.door').length;
    const diff = nextDoorCount - currentDoorCount;
    
    const isRemove = diff < 0;
    for(let i = 1; i <= Math.abs(diff); i++) {
        if (isRemove) {
            $('.door-design-preview .doors door-option').last().remove();
        } else {
            const dynamicDoorClass = 'door-' + new Date().getTime();
            const template = `
                <door-option class="door mirror ${dynamicDoorClass}" 
                data-order="${currentDoorCount-1 + i}" 
                data-type="doorType" 
                data-door-type="doorType"
                data-door-insert="mirror"
                data-value="mirror">
                </door-option>
            `;
            $('.door-design-preview .doors').append(template);
            addModal(dynamicDoorClass);
        }
    
    }
    $('#width-label').text($('#customTopWidth').val() + ' mm');
    $('#height-label').text($('#customHeight').val() + ' mm');

    var totalDoors = $('.door-design-preview .doors .door').length;
    $('.door-design-preview .doors').removeClass('doors-1 doors-2 doors-3 doors-4 doors-5 doors-6').addClass('doors-' + totalDoors);
    calculateDimensions();
}

applyToAllDoors = () => {
    var insertCategory = $('#insertOptionsContainerSideBar .select-menu').attr('data-value').replace(' ', '');
    const element = $('door-option');

    // let className = insertCategory;
    // element.attr('data-type', 'doorType');
    // element.attr('data-value', className);

    // if (insertCategory === 'vinyl') {
    //     var selectedVinyl = $('#vinylOptionsContainerSideBar .select-menu').attr('data-value');
    //     selectedVinyl = selectedVinyl === 'glacier / white' ? 'glacier' : selectedVinyl;
    //     className += ' ' + selectedVinyl;
    //     element.attr('data-type', insertCategory);
    //     element.attr('data-value', selectedVinyl);

    // } else if (insertCategory === 'colonial') {
    //     var selectedColonial = $('#colonialOptionsContainerSideBar .select-menu').attr('data-value');
    //     className += ' ' + selectedColonial;
    //     element.attr('data-type', insertCategory);
    //     element.attr('data-value', selectedColonial);
    // }

    // className = className?.toLowerCase();

    const doorType = $('#insertOptionsContainerSideBar .select-menu').attr('data-door-type');
    let insertMaterial = $('#insertOptionsContainerSideBar .select-menu').attr('data-door-insert');

    if (insertMaterial === 'glacier / white') {
        insertMaterial = 'glacier';
    }


    let className = doorType + ' ' + insertMaterial;

    console.log('@@@ className', className);

    clearInserts(element);
    element.addClass(className);
    element.attr('data-door-type', doorType);
    element.attr('data-door-insert', insertMaterial);
    
    document.querySelectorAll('.door').forEach(door => door.classList.remove('selected'));
    getPricingEstimates();
};

applyToSelectedDoorOnly = (doorType, insertMaterial) => {
    console.log('@@@ applyToDoorSelectedOrFirstDoorOnly');
    const selectedElement = $('door-option.selected');
    const element = selectedElement;

    if (!element) {
        return;
    }

    if (!doorType) {
        doorType = $('#insertOptionsContainerSideBar .select-menu').attr('data-door-type');
    }

    if (!insertMaterial) {
        insertMaterial = $('#insertOptionsContainerSideBar .select-menu').attr('data-door-insert');
    }

    if (insertMaterial === 'glacier / white') {
        insertMaterial = 'glacier';
    }

    let className = doorType + ' ' + insertMaterial;
    clearInserts(element);
    element.addClass(className);
    element.attr('data-door-type', doorType);
    element.attr('data-door-insert', insertMaterial);
    
    document.querySelectorAll('.door').forEach(door => door.classList.remove('selected'));
    getPricingEstimates();

     const modal = document.querySelector('#myModal');
     if (modal) {
        modal.classList.add('hidden');
     }
};

applyToFirstDoorOnly = (doorType, insertMaterial) => {
    console.log('@@@ applyToFirstDoorOnly');
    const element = $('door-option').first();

    if (!doorType) {
        doorType = $('#insertOptionsContainerSideBar .select-menu').attr('data-door-type');
    }

    if (!insertMaterial) {
        insertMaterial = $('#insertOptionsContainerSideBar .select-menu').attr('data-door-insert');
    }

    if (insertMaterial === 'glacier / white') {
        insertMaterial = 'glacier';
    }

    let className = doorType + ' ' + insertMaterial;
    clearInserts(element);
    element.addClass(className);
    element.attr('data-door-type', doorType);
    element.attr('data-door-insert', insertMaterial);
    
    document.querySelectorAll('.door').forEach(door => door.classList.remove('selected'));
    getPricingEstimates();
};

window.addEventListener('resize', function(event) {
    calculateDimensions();
});

let isSetNameValid = false;
let isMeasurementsGroupValid = false;
let isDoorTypeAndInsertColorsValid = false;

const setName = document.getElementById('setName');
const startHere = document.getElementById('startHere');
const groupMeasurements = document.getElementById('group-measurements');
const groupDoorsAndTrackStyle = document.getElementById('group-doors-and-track-style');
const groupDoorsTypes = document.getElementById('group-doors-types');
const insertType = document.getElementById('insertOptionsSideBar');

setName.addEventListener('focus', function() {
    if (setName.value == '') {
        startHere.style.display = 'block';
    }
});

setName.addEventListener('input', function() {
    if (this.value) {
        startHere.style.display = 'none';
        if (!isMeasurementsGroupValid) {
            setTimeout(() => {
                groupMeasurements.classList.add('active');
                isSetNameValid = true;
            }, 1000);
        }
    }
});

const inputs1 = ['customTopWidth', 'customBottomWidth', 'customLeftHeight', 'customRightHeight'];
let focusCount = 0;

inputs1.forEach(inputId => {
    const input = document.getElementById(inputId);

    input.addEventListener('focus', function() {
        focusCount++;
    });

    input.addEventListener('blur', function() {
        setTimeout(() => {
            focusCount--;
            if (focusCount === 0 && !isMeasurementsGroupValid) {
                groupMeasurements.classList.remove('active');
                groupDoorsAndTrackStyle.classList.add('active');
                groupDoorsAndTrackStyle.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                isMeasurementsGroupValid = true;
            }
        }, 0);
    });
});

if (insertType) {
    // insertType.addEventListener('click', function() {
    //     if (!isDoorTypeAndInsertColorsValid) {
    //         setTimeout(() => {
    //             groupDoorsTypes.classList.add('active');
    //             groupDoorsTypes.scrollIntoView({
    //                 behavior: 'smooth',
    //                 block: 'start'
    //             });
    //             groupDoorsAndTrackStyle.classList.remove('active');
    //         }, 1000);
    //     }
    // });

    insertType.addEventListener('blur', function() {
        isDoorTypeAndInsertColorsValid = true;
        setTimeout(() => {
            groupDoorsTypes.classList.remove('active');
        }, 2000);
    });
}